import React from "react";
import CreatorContent from "./CreatorContent";

const CreatorLibrary: React.FC = () => {
  return <CreatorContent />;
};

export default CreatorLibrary;